<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="ChevronLeftIcon" @click="close()" />
    </template>
    <template #title>{{ items.length }} files</template>

    <Sheet.Body class="px-0!">
      <template v-for="(item, index) in items" :key="index">
        <div class="flex h-16 w-full items-center gap-4 px-4">
          <div class="w-10 shrink-0">
            <Thumbnail :type="item.type" :src="item.src" />
          </div>
          <p
            class="truncate font-secondary text-[16px] leading-[20px] text-gray-800"
          >
            {{ item.name }}
          </p>
        </div>
        <div
          v-if="index < items.length - 1"
          class="ml-[72px] mr-4 h-px bg-gray-800/10"
        />
      </template>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { onBeforeUnmount } from 'vue'
import { Sheet, Thumbnail, useSheet, type ThumbnailType } from '@dacr/library'
import { ChevronLeftIcon } from '@dacr/icons'
import { useUploadStore } from '@/features/upload/store'

const { close } = useSheet()
const uploadStore = useUploadStore()

const thumbType = (file: File): ThumbnailType => {
  const type = file.type
  if (type.startsWith('image/')) return 'image'
  if (type.startsWith('audio/')) return 'audio'
  if (type.startsWith('video/')) return 'video'
  if (type === 'application/pdf') return 'pdf'
  return 'generic'
}

const objectUrls: string[] = []

const items = (uploadStore.draft?.files ?? []).map((file) => {
  const type = thumbType(file)
  let src: string | undefined
  if (type === 'image') {
    src = URL.createObjectURL(file)
    objectUrls.push(src)
  }
  return { name: file.name, type, src }
})

onBeforeUnmount(() => objectUrls.forEach((url) => URL.revokeObjectURL(url)))
</script>
